import { ApiError } from '@/api';

/**
 * The error a raw `fetch` list read throws on a non-2xx answer, shaped like
 * the generated client's `ApiError` (status, body with `code` and `message`).
 * `errorToastText`, `QueryErrorState` and the retry rules read those fields, so
 * a failed read shows the backend's words and a 403 its own wording instead of
 * "Failed to fetch contracts: 500 Internal Server Error".
 */
export async function apiErrorFromResponse(response: Response, url: string, what: string): Promise<ApiError> {
  let body: unknown;
  try {
    body = await response.json();
  } catch {
    body = undefined;
  }
  return new ApiError(
    { method: 'GET', url },
    { url, ok: false, status: response.status, statusText: response.statusText, body },
    `${what}: ${response.status}`,
  );
}
